import { PRODUCTION_STAFF_APEX, STAFF_APEX_DOMAIN } from "@v1/backend/logic/organizations/staff_host";

/** Light/dark choice shared by website and docs host: localStorage is per host, this cookie is not. */
export const SHARED_THEME_COOKIE = "hv-theme";

const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

type SharedTheme = "light" | "dark";

/** Staff apex (website) and its subdomains (docs) share one cookie; other hosts keep their own. */
function cookieDomainFor(hostname: string): string | null {
  for (const apex of [PRODUCTION_STAFF_APEX, STAFF_APEX_DOMAIN]) {
    if (hostname === apex || hostname.endsWith(`.${apex}`)) return apex;
  }
  return null;
}

export function readSharedTheme(): SharedTheme | null {
  try {
    const match = /(?:^|; )hv-theme=(dark|light)/.exec(document.cookie);
    return match?.[1] === "dark" || match?.[1] === "light" ? match[1] : null;
  } catch {
    return null;
  }
}

export function writeSharedTheme(theme: SharedTheme): void {
  try {
    const domain = cookieDomainFor(window.location.hostname);
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    const scope = domain === null ? "" : `; Domain=.${domain}`;
    document.cookie = `${SHARED_THEME_COOKIE}=${theme}; Path=/; Max-Age=${ONE_YEAR_SECONDS}; SameSite=Lax${scope}${secure}`;
  } catch {
    // Cookies blocked: each host keeps its own choice.
  }
}
